<template>
    <div class="container" style="background-color:white; border: 1px solid #ccc; border-radius:5px; padding:16px; ">
        <div class="bold f14">Define Payment Terms</div>

        <div class="row mt-2">
            <div class="col-md-3 col-12" style="align-content:end;">
               
                <div class="f12" v-if="type == 1">Total Cost of Project<span class="mandatory">*</span></div>
                <div class="f12" v-if="type == 0">Total Payable to the Sub-Contractor</div>
                <CurrencyInput v-model:value="totalCost" style="height: 34px; width: 100%;" class="form-control" placeholder="Enter total cost" />
                    
            </div>

            <div class="col-md-6 col-12 " style="align-content:end; display:flex; gap: 8px;">
                <div  style="flex: 1;" class="deposit-area">
                    <div class="f12">Deposit Amount</div>
                    <CurrencyInput v-model:value="depositAmount" style="height: 34px; width: 100%;" class="form-control" placeholder="Enter deposit Amount" />

                </div>
                <div  class="deposit-area">
                    <div class="f12">Choose Date to Pay Deposit</div>
                    <date-picker  :disabled-date="disabledBeforeToday" :value="depositDate" valueType="format" @change="(x)=>{depositDate = x}"></date-picker>

                </div>

            </div>

            <div class="col-md-3 col-12" style="align-content:end;">
                <div class="f12">Remaining Amount</div>
 
                <input type="text"  style="height: 34px;" v-model="remainingAmount" class="form-control" readonly />
            </div>
             
        </div>
        
        <div class="row">
            <div class="col-12 text-center mt-4 f12">Select your payment option for the outstanding balance.</div>
            <div class="col-12">
                <div style="display:flex; flex-wrap:wrap; justify-content:center;">
                    <button type="button" class="btn btn-primary buttons" @click="setMode('date')" :class="{ 'btn-pressed': mode === 'date' }">By Date</button>
                     
                    <button type="button" class="btn btn-secondary buttons" @click="setMode('milestone')" :class="{ 'btn-pressed': mode === 'milestone' }">By Milestone</button>
                    <button type="button" class="btn btn-success buttons" @click="setMode('percentage')" :class="{ 'btn-pressed': mode === 'percentage' }">By Percentage</button>
                    <button type="button" class="btn btn-warning buttons" @click="setMode('custom')" :class="{ 'btn-pressed': mode === 'custom' }">Custom</button>
                </div>
            </div>
        </div>

       

        <div v-if="mode === 'date'">
            <div class="row">
                <div class="f12 text-center bold" style="margin: 8px 0px;"> Set date for the remaining payment</div>

                <div class="col-12" style="margin:0px; padding:0px; display:none;">
                    <div class="btn-text" style="height:unset;" @click="addPaymentDate"><span class="text">Add new payment date</span><div class="material-icons">add_circle</div></div>
                </div>
            </div>
            
            <div v-for="(payment, index) in paymentDates" :key="index"  style="display:flex; gap:8px; justify-content:center;">
                <div :style="{ 'margin-top': index === 0 ? '32px':'16px' }">{{index+1}}</div>
                <div class="text-center">
                    <div class="f12 bold" v-if="index === 0">Payment Date</div>
                    <input type="date" :min="StartDate" v-model="payment.Name" class="form-control"  style="max-width: 160px; margin: 8px auto"/>
                    
                </div>
                <div class="text-center">
                    <div class="f12 bold" v-if="index === 0"> Amount</div>
                     <CurrencyInput v-model:value="payment.Amount" style="max-width: 160px; margin:8px auto" class="form-control" placeholder="Enter Amount" :input="updateRemainingAmount" @updateAmount="updatePaymentAmount" :index="index"/>

                </div>
                <div :style="{ 'margin-top': index === 0 ? '28px':'12px',  'width':'64px' }">

                    <div v-if="paymentDates.length > 1" class="material-icons unselectable" style="color:red; " @click="deleteOption(index);">delete</div>
                    <div v-show="index == paymentDates.length - 1 && remainingAmount != 0" class="material-icons unselectable" @click="addPaymentDate">add_circle</div>
                </div>
               
            </div>

        </div>

        <div v-if="mode === 'milestone'">
           
            <div class="row">
                <div class="f12 text-center bold" style="margin: 8px 0px;"> Select your payment option for the outstanding balance.</div>
                 
            </div>
             
            <div v-for="(milestone, index) in milestones" :key="index" style="margin: 6px 0; display:flex; flex-wrap:wrap; align-items:center;" :class="getRowClass(index)">

                <span class="milestone-text">When </span>
                <select v-model="milestone.Name" class="form-select milestone-select" style="max-width: 150px; margin:4px;">
                    <option v-for="item in selections" :value="item" :key="item">{{item}}</option>
                </select>

                <input v-if="milestone.Name === 'Other Type'" v-model="milestone.CustomName" class="form-control milestone-input" style="max-width: 150px; margin: 4px; font-size:12px;" placeholder="Enter milestone type" />

                <span class="milestone-text">is completed,</span> <span class="milestone-text">a payment Amount of</span>
                 <CurrencyInput v-model:value="milestone.Amount" style="max-width: 120px; margin: 4px;" class="form-control milestone-input" placeholder="Enter Amount" :input="updateRemainingAmount" @updateAmount="updatePaymentAmount" :index="index" />

                    
                <span class="milestone-text">is due</span>

                <div :style="{ 'width':'64px' }">

                    <div v-if="milestones.length > 1" class="material-icons unselectable" style="color:red; " @click="deleteOption(index);">delete</div>
                    <div v-show="index == milestones.length - 1 && remainingAmount != 0" class="material-icons unselectable" @click="addMilestone">add_circle</div>
                </div>
               
            </div>

        </div>

        <div v-if="mode === 'percentage'">

            <div class="row">
                <div class="f12 text-center bold" style="margin: 8px 0px;"> Select your payment option for the outstanding balance.</div>

            </div>

            <div v-for="(percentage, index) in percentages" :key="index" style="margin: 6px 0; display:flex; flex-wrap:wrap; align-items:center;" :class="getRowClass(index)">

                <span class="milestone-text">When </span>
                <select v-model="percentage.Name" class="form-select milestone-select" style="max-width: 150px; margin:4px;">
                    <option v-for="item in selections" :value="item" :key="item">{{item}}</option>
                </select>

                <input v-if="percentage.Name === 'Other Type'" v-model="percentage.CustomName" class="form-control milestone-input" style="max-width: 150px; margin: 4px; font-size:12px;" placeholder="Enter type" />

                <span class="milestone-text">is completed</span>
                <input type="number" max="100" v-model.number="percentage.Amount" class="form-control milestone-input" style="max-width: 100px; margin:4px;" placeholder="Enter Other" @input="updateRemainingAmount(index)" />
                <span class="milestone-text">% </span><span class="milestone-text">of {{formatCurrency(totalCost- depositAmount)}} ({{formatCurrency((totalCost- depositAmount)/100 * percentage.Amount) }}) is due</span>

                <div :style="{  'width':'64px' }">

                    <div v-if="percentages.length > 1" class="material-icons unselectable" style="color:red; " @click="deleteOption(index);">delete</div>
                    <div v-show="index == percentages.length - 1 && remainingAmount != 0" class="material-icons unselectable" @click="addPercentage">add_circle</div>
                </div>


            </div>

            <div class="text-center bold" :style="{'color':totalPercentage == 100? 'green': 'red', 'font-size': '12px', 'margin-top': '16px'}">{{totalPercentage}}% of 100%</div>

        </div>

        <div v-if="mode === 'custom'">
            <div class="row">
                <div class="f12 text-center bold" style="margin: 8px 0px;"> Custom Payment Terms</div>
 
            </div>
            <textarea v-model="customTerms" class="form-control" style="height: 150px" placeholder="Please describe your own custom payment terms by detailing how you would like to get paid"></textarea>
        </div>

       
    </div>
</template>

<script>

    import DatePicker from 'vue-datepicker-next';
    import 'vue-datepicker-next/index.css';
    import CurrencyInput from './CurrencyInput.vue';
import { max } from 'moment';

    export default {
        components: {
            DatePicker, CurrencyInput
        },
        props: {
            initialData: {
                type: Object,
                default: () => ({})
            },
            type: {
                type: Number, 
                default: 1
            },
            StartDate: {
                type: String,
                default: new Date().toISOString().split("T")[0]
            }
        },

        data() {
            return {
                totalCost: this.initialData.TotalCost || 0,
                depositAmount: this.initialData.Deposit || 0,
                mode: this.initialData.Mode || null,
                paymentDates: this.initialData.Mode === 'date' ? this.initialData.Terms : [{ Name: this.formatDate(new Date()), Amount: 0 }],

                milestones: this.initialData.Mode === 'milestone' ? this.initialData.Terms : [{ Name: '', Amount: 0, CustomName: '' }],
                percentages: this.initialData.Mode === 'percentage' ? this.initialData.Terms : [{ Name: '', Amount: 0, CustomName: '' }],
                customTerms: this.initialData.Mode === 'custom' ? this.initialData.Terms : '',
                totalPercentage: 0,
                depositDate: this.initialData.DepositDate || this.formatDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000)),
                selections: ['Other Type', 'Architectural Drawings & Permits', 'Carpentry','Concrete', 'Demolition', 'Drywall/Plaster', 'Electrical', 'Excavation', 'Fire Sprinkler Installation', 'Flashing/Eavestroughs', 
                'Flooring','Framing', 'Gas', 'Glass and Glazing', 'HVAC', 'Insulation', 'Landscaping', 'Masonry', 'Painting', 'Plaster', 'Plumbing', 'Roofing', 'Taping','Tiling', 'Underpinning','Welding'],
            
                
                
            };
        },
        computed: {
            remainingAmount() {
                let total = this.totalCost - this.depositAmount;
                if (this.mode === 'date') {
                    this.paymentDates.forEach(payment => total -= payment.Amount);
                } else if (this.mode === 'milestone') {
                    this.milestones.forEach(milestone => total -= milestone.Amount);
                } else if (this.mode === 'percentage') {
                    this.percentages.forEach(percentage => total -= (this.totalCost - this.depositAmount) * (percentage.Amount / 100));

                }

                if (total < 0.01 && total > -0.01) total = 0;

                return this.formatAsCurrency( Math.round((total) * 100) / 100 );
            }
        },

        watch: {
            totalCost() {
                this.getRemainingAmount();
            },
            deposit() {
                this.getRemainingAmount();
            },
            
        },

        methods: {


            getRowClass(index) {
                return (index % 2) === 0 ? 'bg-purple' : 'bg-light';
            },
            // Format raw number as currency (e.g., 100 => "$100.00")
            formatAsCurrency(value) {
                if (value === null || value === undefined || isNaN(value)) return "";
                return new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                }).format(value);
            },
  
            formatCurrency(Amount) {
                return this.formatAsCurrency(Amount);
            },
            
            initData(data) {
                console.log("initData", data);
                this.totalCost = data.TotalCost || 0;
                this.depositAmount = data.Deposit || 0;
                this.mode = data.Mode || 0;
                this.paymentDates = data.Mode === 'date' ? data.Terms : [{ Name: this.formatDate(new Date()), Amount: 0, CustomName: '' }];
                this.milestones = data.Mode === 'milestone' ? data.Terms : [{ Name: '', Amount: 0, CustomName: ''}];
                this.percentages = data.Mode === 'percentage' ? data.Terms : [{ Name: '', Amount: 0 }];
                this.customTerms = data.Mode === 'custom' ? data.CustomTerms : '';

                this.depositDate = data.DepositDate || this.formatDate(new Date(new Date().getTime() + 24 * 60 * 60 * 1000));

             
                //add the custom Name support
                if (this.mode === 'milestone') {
                    this.milestones.forEach((milestone) => {
                        if (!this.selections.includes(milestone.Name) ) {
                            milestone.CustomName = milestone.Name;
                            milestone.Name = 'Other Type';
                        }
                    });
                }

                this.totalPercentage = 0; // reset before summing
                if (this.mode === 'percentage') {
                    
                    this.percentages.forEach((percentage) => {
                        if (!this.selections.includes(percentage.Name) ) {
                            percentage.CustomName = percentage.Name;
                            percentage.Name = 'Other Type';
                        }

                        this.totalPercentage += percentage.Amount;
                    });
                }

                this.getRemainingAmount();
            },
            getRemainingAmount() {
                let total = this.totalCost - this.depositAmount;
                if (this.mode === 'date') {
                    this.paymentDates.forEach(payment => total -= payment.Amount);
                } else if (this.mode === 'milestone') {
                    this.milestones.forEach(milestone => total -= milestone.Amount);
                } else if (this.mode === 'percentage') {
                    this.percentages.forEach(percentage => total -= (this.totalCost - this.depositAmount) * (percentage.Amount / 100));
                }

                if (total < 0.01 && total > -0.01) total = 0;

                return total;
            },

            deleteOption(idx) {
                if (this.mode === 'date') {
                    this.paymentDates.splice(idx, 1);
                } else if (this.mode === 'milestone') {
                    this.milestones.splice(idx, 1);
                } else if (this.mode === 'percentage') {
                    this.percentages.splice(idx, 1);
                }

                this.calculateTotalPayments();
            },
            setMode(mode) {
                this.mode = mode;
            },
            addPaymentDate() {
                this.paymentDates.push({ Name: this.formatDate(new Date()), Amount: 0 });
            },
            addMilestone() {
                this.milestones.push({ Name: '', Amount: 0, CustomName: '' });
            },
            addPercentage() {
                this.percentages.push({ Name: '', Amount: 0, CustomName: '' });
            },

            updatePaymentAmount(amount, index) {

                //console.log("updatePaymentAmount", amount, index);
              
                 if(this.mode === 'milestone'){

                    const total = this.milestones.reduce(
                        (sum, item, i) => sum + (i === index ? 0 : item.Amount || 0),
                        0   
                    )

                    const maxAmount = this.totalCost - this.depositAmount - total;

                    const inputAmount = amount || 0;
             
                    if( inputAmount > maxAmount){
                      
                        this.milestones[index].Amount = maxAmount;
                    }else{
                        this.milestones[index].Amount = amount;
                    }

                     
                }else if(this.mode === 'date'){
 
                    const total = this.paymentDates.reduce(
                        (sum, item, i) => sum + (i === index ? 0 : item.Amount || 0),
                        0   
                    )

                    const maxAmount = this.totalCost - this.depositAmount - total;

                    const inputAmount = amount || 0;
                    //console.log("inputAmount", inputAmount);    
                    //console.log("max amount", maxAmount);    
                    if( inputAmount > maxAmount){
                        //console.log("over max", maxAmount, total, inputAmount);
                        this.paymentDates[index].Amount = maxAmount;
                    }else{
                        this.paymentDates[index].Amount = amount;
                    }

                    //console.log(this.paymentDates, maxAmount, total, inputAmount);
                }
            },

            updateRemainingAmount(index = 0) {
                this.totalPercentage = 0;
                //this.remainingAmount = this.totalCost - this.depositAmount - this.calculateTotalPayments();
                //console.log("updateRemainingAmount", "called", index);

                if (this.mode === 'percentage') {
                    const total = this.percentages.reduce(
                        (sum, item, i) => sum + (i === index ? 0 : item.Amount || 0),
                        0
                    );

                    const inputAmount = this.percentages[index].Amount || 0;

                    if (total + inputAmount > 100) {
                        this.percentages[index].Amount = Math.max(0, 100 - total); // Adjust value to not exceed 100
                    }

                    this.percentages.forEach(percentage => this.totalPercentage += percentage.Amount);
                   
                }
            },
            calculateTotalPayments() {
                let total = 0;
                if (this.mode === 'date') {
                    this.paymentDates.forEach(payment => total += payment.Amount);
                } else if (this.mode === 'milestone') {
                    this.milestones.forEach(milestone => total += milestone.Amount);
                } else if (this.mode === 'percentage') {
                    this.percentages.forEach(percentage => total += (this.totalCost - this.depositAmount) * (percentage.Amount / 100));
                }
                return total;
            },
            finish() {
                // Save the payment terms data here, you can make an API call or perform any action needed
               //alert('Payment terms saved!');
                var data = [];
                var customTerms = "";
                if (this.mode === 'date') {
                    //sort the date list by date
                    data = this.paymentDates.sort((a, b) => new Date(a.Name) - new Date(b.Name));
                     
                } else if (this.mode === 'milestone') {
                    //data = JSON.stringify(this.milestones);
                    data = this.milestones;


                } else if (this.mode === 'percentage') {
                    //data = JSON.stringify(this.percentages);
                    data = this.percentages;
                } else if (this.mode === 'custom') {
                    customTerms = this.customTerms;
                    //data = JSON.stringify(this.customTerms);
                }

                data = JSON.parse(JSON.stringify(data));
                data.forEach((d) => {
                    if (d.Name === 'Other Type') {
                        d.Name = d.CustomName;
                    }                    
                });

                var dataObj = {
                    TotalCost: this.totalCost,
                    Deposit: this.depositAmount,                 
                    Mode: this.mode,
                    DepositDate: this.depositDate,
                    Remain: this.getRemainingAmount(),
                    Terms: data,
                    CustomTerms: customTerms
                };
                return dataObj;
                //this.$emit('savePaymentTerms', dataObj);
            },

            formatDate(date) {
                var month = '' + (date.getMonth() + 1);
                var day = '' + date.getDate();
                var year = date.getFullYear();

                if (month.length < 2)
                    month = '0' + month;
                if (day.length < 2)
                    day = '0' + day;

                return [year, month, day].join('-');
            },
            disabledBeforeToday(date) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                return date < today;
            }
        }
    };
</script>

<style scoped>
 
    .btn-primary{ background-color: #2080f0;}
    .btn-primary:hover{ background-color: #4098fc;}
    .btn-success{ background-color: #ABC946FF;}
    .btn-success:hover{ background-color: #BEE638FF;}

  
 
    .btn-pressed {
        box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.58); /* Subtle shadow */
    }
    .f14{font-size:14px;}
    .f12 {
        font-size: 12px;
    }
    .buttons{
        margin: 8px 4px;
        font-size: 12px;
        min-width: 100px;
        height: 30px;
        line-height:30px;
    }

    .milestone-item {
        margin: 6px 0;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }

    .milestone-text {
        margin: 4px;
        flex-basis: auto;
        font-size:clamp(12px, 1.5vw, 16px);
    }
    .milestone-select,
    .milestone-input {
        margin: 4px;
        flex-basis: auto;
        min-width: 80px;
    }
    .deposit-area {
        align-content: end;
    }
    @media (max-width: 600px) {
        .milestone-item {
            flex-direction: column;
            align-items: flex-start;
        }
        .milestone-select{max-width: 100px !important; font-size: 12px; height: 30px; padding-left: 8px;}
        .milestone-input{min-width:60px; width: 60px; font-size: 12px; height: 30px; padding-left: 8px;}
        .milestone-text,
        .milestone-select,
        .milestone-input {
            margin: 2px 0;
            
        }

        .bg-light{ background-color: #ECECECFF; padding: 4px; border-radius: 4px;}
        .bg-purple{ background-color: #eeecfc; padding: 4px; border-radius: 4px;}
    }
</style>
